import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c('BlocklyComponent',{ref:"foo",attrs:{"id":"blockly2","options":_vm.options},on:{"input":_vm.showCode},model:{value:(_vm.workspaceData),callback:function ($$v) {_vm.workspaceData=$$v},expression:"workspaceData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }